import { Link } from 'react-router-dom';

export default function EstadoVazio({ mes }: { mes?: string }) {
  return (
    <div className="mt-8 flex flex-col items-center justify-center rounded-xl border border-secondary-200 bg-white px-6 py-14 text-center">
      <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
        <i className="ri-calendar-2-line text-xl" />
      </span>
      <p className="mt-4 text-[15px] text-foreground-800">
        {mes
          ? `Nada marcado em ${mes}. Bom mês para o seu evento.`
          : 'Nada marcado por aqui. Bom momento para o seu evento.'}
      </p>
      <Link
        to="/criar"
        className="mt-6 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
      >
        <span className="flex h-4 w-4 items-center justify-center">
          <i className="ri-add-line" />
        </span>
        Criar evento
      </Link>
    </div>
  );
}